import React from 'react';
import { Heart } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import './footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-text">
          <p className="copyright">
            © {currentYear} {t('footer.copyright')}
          </p>
          <p className="made-by">
            {t('footer.madeWith')} <Heart size={16} className="heart-icon" /> 
            {t('footer.by') && ` ${t('footer.by')} `}
            <a 
              href="https://jijanurrahman.netlify.app" 
              target="_blank" 
              rel="noopener noreferrer"
              className="creator-link"
            >
              Jijanur Rahman
            </a>
          </p>
        </div>
      </div>
      <div className="footer-decoration"></div>
    </footer>
  );
};

export default Footer;
